import NavBar from "./NavBar";
import registerBg from "../assets/figma/register-bg-v2.png";

type LoadingTone = "light" | "dark";

type LoadingSize = "sm" | "md";

interface SpinnerProps {
  tone?: LoadingTone;
  size?: LoadingSize;
  className?: string;
}

interface AppLoadingProps extends SpinnerProps {
  variant?: "spinner" | "inline" | "fullscreen";
  text?: string;
  fullScreenTitle?: string;
  showFullScreenNav?: boolean;
}

function spinnerSizeClass(size: LoadingSize): string {
  return size === "sm" ? "h-5 w-5 border-2" : "h-16 w-16 border-[5px]";
}

function spinnerToneClass(tone: LoadingTone): string {
  return tone === "dark"
    ? "border-[#111]/30 border-t-[#111]"
    : "border-white/30 border-t-white";
}

function Spinner({ tone = "light", size = "md", className = "" }: SpinnerProps) {
  return (
    <div
      className={`${spinnerSizeClass(size)} animate-spin rounded-full ${spinnerToneClass(tone)} ${className}`.trim()}
      aria-hidden="true"
    />
  );
}

export default function AppLoading({
  variant = "spinner",
  text,
  tone = "light",
  size = "md",
  className = "",
  fullScreenTitle,
  showFullScreenNav = true,
}: AppLoadingProps) {
  if (variant === "fullscreen") {
    return (
      <div className="relative min-h-screen overflow-hidden bg-linear-to-b from-[#3D3D3D] to-[#111111] text-white">
        <img src={registerBg} alt="" className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-100" />

        {showFullScreenNav ? <NavBar title={fullScreenTitle} fixed glass /> : null}

        <main className="relative z-10 flex min-h-screen items-center justify-center px-6">
          <Spinner tone="light" />
        </main>
      </div>
    );
  }

  if (variant === "inline") {
    return (
      <div className={`flex items-center justify-center gap-2 text-[#b0b0b0] ${className}`.trim()}>
        <Spinner tone={tone} size={size} />
        {text ? <span>{text}</span> : null}
      </div>
    );
  }

  return <Spinner tone={tone} size={size} className={className} />;
}
